import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-39c0b9ac"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = {
  class: "menuContainer max-width"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "logoContainer"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "logo"
  })], -1);
});

var _hoisted_4 = {
  class: "menu"
};
var _hoisted_5 = {
  class: "buttons"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "line fl"
  }, "|", -1);
});

var _hoisted_7 = {
  key: 0,
  class: "accountBox"
};
var _hoisted_8 = {
  class: "el-dropdown-link head"
};
var _hoisted_9 = {
  class: "account"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode("会员中心");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("退出登录");

var _hoisted_12 = {
  key: 1
};

var _hoisted_13 = /*#__PURE__*/_createTextVNode("注册");

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { menusList } from './menusList';
import { useStore } from 'vuex';
export default {
  setup: function setup(__props) {
    var store = useStore();
    var route = useRouter();
    var account = localStorage.getItem('account');
    var squareUrl = ref('https://img0.baidu.com/it/u=2601170227,3207786263&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500');

    var login = function login() {
      route.push('Login');
    };

    var defaultActive = ref(sessionStorage.getItem('homePath') || '/home');

    var savePath = function savePath(path) {
      sessionStorage.setItem('homePath', "/".concat(path));
    };

    var logout = function logout() {
      store.dispatch('app/logout');
    };

    var userInfo = function userInfo() {
      route.push('userInfo');
    };

    return function (_ctx, _cache) {
      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_el_menu = _resolveComponent("el-menu");

      var _component_el_avatar = _resolveComponent("el-avatar");

      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      var _component_el_dropdown = _resolveComponent("el-dropdown");

      var _component_router_link = _resolveComponent("router-link");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_menu, {
        "default-active": defaultActive.value,
        class: "el-menu-demo",
        mode: "horizontal",
        router: "",
        onSelect: _ctx.handleSelect
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menusList), function (item) {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              index: item.path,
              key: item.path,
              onClick: function onClick($event) {
                return savePath(item.path);
              }
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("span", null, _toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["index", "onClick"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["default-active", "onSelect"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _unref(account) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: userInfo
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: logout
              }, {
                default: _withCtx(function () {
                  return [_hoisted_11];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: squareUrl.value
          }, null, 8, ["src"])]), _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(account)), 1)];
        }),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
        onClick: login,
        class: "button"
      }, "登录"), _createVNode(_component_router_link, {
        to: "register",
        class: "button"
      }, {
        default: _withCtx(function () {
          return [_hoisted_13];
        }),
        _: 1
      })]))])])]);
    };
  }
};